export default "__VITE_ASSET__DwPU9efy__"